function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import I18N from '@leverege/i18n';
import { Pane, Flex, TextInput, Text, Label, NumericInput, Checkbox } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import CardGrid from "./CardGrid.js";
import CardSelector from "./CardSelector.js";
import DashboardContext, { useDashboardContext } from "../shared/DashboardContext.js";
import VariantCreator from "../shared/VariantCreator.js";
import { Grid } from "../model/index.js";
import S from './GridEditor.css';
const {
  t
} = I18N.ns('uiDashboard.editor.GridEditor');
export default function GridEditor(props) {
  let {
    addText,
    placeholderContent
  } = props;
  let {
    value
  } = props;
  value = value || {};
  const {
    style,
    className,
    onAdd,
    ...rProps
  } = props;
  const dashboardContext = useDashboardContext();
  const {
    addWidgetText,
    models,
    options,
    optionEditors,
    depth,
    sharedProps
  } = dashboardContext;
  const onModelChange = useValueChange(Grid, props);
  const ovc = new VariantCreator('OptionsEditor', value.style);
  if (addText == null) {
    addText = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-plus"
    }), " ", addWidgetText || t('addWidget'));
  }
  if (placeholderContent == null) {
    placeholderContent = /*#__PURE__*/React.createElement("div", {
      className: S.addWidget
    }, /*#__PURE__*/React.createElement(CardSelector, {
      title: addText,
      onSelect: onAdd
    }));
  }
  const mdl = depth === 0 && models.create(value);
  const req = mdl && mdl.getRequired && mdl.getRequired(value, models, dashboardContext);
  if (req && req.length > 0) {
    return /*#__PURE__*/React.createElement(DashboardContext, {
      depth: depth + 1,
      options: value.options
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "colM",
      align: "right",
      style: style,
      className: className
    }, /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      variant: `${ovc.get()}|rowM`
    }, /*#__PURE__*/React.createElement(Label, null, t('dashboardOptions')), req.map(req => {
      const onChange = evt => {
        const options = value.options ? {
          ...value.options
        } : {};
        options[req] = evt.value;
        onModelChange({
          data: 'setOptions',
          value: options
        });
      };
      const oProps = {
        key: req,
        eventData: req,
        value: value.options[req] || options[req],
        sharedProps,
        onChange
      };
      return optionEditors.create(req, oProps);
    })), /*#__PURE__*/React.createElement(CardGrid, _extends({
      placeholderContent: placeholderContent
    }, rProps))));
  }
  return /*#__PURE__*/React.createElement(DashboardContext, {
    depth: depth + 1,
    options: value.options,
    columns: Grid.getColumns(value) || 2
  }, /*#__PURE__*/React.createElement(CardGrid, _extends({
    placeholderContent: placeholderContent
  }, rProps, {
    style: style,
    className: className,
    sharedProps: sharedProps
  })));
}
GridEditor.MenuEditor = function (props) {
  const {
    value,
    maxColumns
  } = props;
  const onModelChange = useValueChange(Grid, props);
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "padding"
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    align: "stretch"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "title"
  }, t('gridOptions')), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    align: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "dashboardCardEditor|small"
  }, t('columns')), /*#__PURE__*/React.createElement(NumericInput, {
    variant: "dashboardCardEditor|small",
    size: 2,
    value: value.columns || 1,
    eventData: "setColumns",
    min: 1,
    max: maxColumns,
    onChange: onModelChange
  })), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    align: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "dashboardCardEditor|small"
  }, t('columnWidth')), /*#__PURE__*/React.createElement(TextInput, {
    variant: "dashboardCardEditor|small",
    size: 8,
    value: value.columnSize || '1fr',
    eventData: "setColumnSize",
    min: 1,
    onChange: onModelChange
  })), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    align: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "dashboardCardEditor|small"
  }, t('rowGap')), /*#__PURE__*/React.createElement(TextInput, {
    variant: "dashboardCardEditor|small",
    value: value.rowGap || '24px',
    eventData: "setRowGap",
    onChange: onModelChange
  })), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    align: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: "dashboardCardEditor|small"
  }, t('columnGap')), /*#__PURE__*/React.createElement(TextInput, {
    variant: "dashboardCardEditor|small",
    value: value.columnGap || '24px',
    eventData: "setColumnGap",
    onChange: onModelChange
  })), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    align: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('showOptions'),
    variant: "dashboardCardEditor|small",
    value: Grid.getShowOptions(value),
    eventData: "setShowOptions",
    onChange: onModelChange
  }))));
};
GridEditor.TYPE = Grid.TYPE;
GridEditor.NAME = 'Grid';
GridEditor.ICON = 'fa fa-th';